import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

const AdjustmentForm = ({ adjustmentValues, setAdjustmentValues, saveAdjustments }) => {
  const { register, handleSubmit, setValue, watch } = useForm({
    defaultValues: adjustmentValues
  });

  // Watches for changes in form data
  const watchAllFields = watch();

  // Update form defaults if adjustmentValues change
  useEffect(() => {
    Object.keys(adjustmentValues).forEach((fieldId) => {
      setValue(fieldId, adjustmentValues[fieldId]?.value || 0); // Default to 0 if value is undefined
    });
  }, [adjustmentValues, setValue]);

  // Update adjustment values on each change
  const onSubmit = (data) => {
    const cleanedData = Object.keys(data).reduce((acc, key) => {
      // Ensure the value is either a number or default to 0
      acc[key] = {
        ...adjustmentValues[key],
        value: data[key] !== '' ? parseFloat(data[key]) : 0, // Convert to number, or set 0 if empty
      };
      return acc;
    }, {});

    setAdjustmentValues(cleanedData); // Set cleaned adjustment values
    saveAdjustments(); // Save adjustments
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="w-full mt-4">
      {/* <h3 className="text-xl font-bold mb-2">Adjust Areas in Need of More Sacrifice & Discipline</h3> */}

      {/* Iterate over adjustmentValues */}
      {Object.keys(adjustmentValues).map((fieldId) => (
        <div key={fieldId} className="mb-4">
          <label className="block text-gray-700">
            {fieldId.replace(/[_\.]/g, ' ')} {/* Replace _ and . with spaces for display */}
          </label>
          <input
            type="number"
            {...register(fieldId)}  // Register the field with react-hook-form
            className="block w-full mt-2 p-2 border rounded-md"
          />
        </div>
      ))}

      <button
        type="submit"
        className="px-8 py-2 mt-4 bg-blue-500 text-white font-bold rounded-full hover:bg-blue-600"
      >
        Save Adjustments
      </button>
    </form>
  );
};

export default AdjustmentForm;
